<template>
  <div class="child-list">
    <div v-if="children" class="row">
      <span v-if="type === 'birthdays'">
        <div
            v-for="child in children"
            :key="child.id"
            class="col-12 child"
        >
          <child-list-item-birthday
              v-if="getChildIsVisibleById(child.child_id)"
              :child="child"
          />
        </div>
      </span>
      <span v-else-if="type === 'mutations'">
        <div
            v-for="child in children"
            :key="child.id"
            class="col-12 child"
        >
          <child-list-item-mutations
              v-if="getChildIsVisibleById(child.child_id)"
              :child="child"
          />
        </div>
      </span>
      <div v-else-if="children && children.length < 1" class="col-12 no-children text-center">
        <p>Geen kinderen</p>
      </div>
      <div
          v-else
          v-for="child in customSortChildren(children)"
          :key="child.id"
          class="col-12 child"
      >
        <child-list-item-select
          :childReset="child.reset"
          :child="child"
          :selected="isSelected(child)"
          :route="route"
          :showMessageInfo="getShowMessageInfo()"
          :messageInfo="getMessageInfoForChild(child)"
        ></child-list-item-select>
      </div>
    </div>
  </div>
</template>

<script>
import ChildListItemBirthday from '@/components/Child-List-Item-Birthday'
import ChildListItemMutations from '@/components/Child-List-Item-Mutations'
import ChildListItemSelect from '@/components/Child-List-Item-Select'
export default {
  name: 'child-list',
  props: ['type', 'filteredChildren', 'route', 'unreadMessagesCount'],
  components: {
    ChildListItemBirthday,
    ChildListItemMutations,
    ChildListItemSelect
  },
  computed: {
    children () {
      if (this.filteredChildren) {
        return this.getPartialChildren(this.filteredChildren)
      }
      return this.getChildren()
    },
    selectedChild () {
      return this.$store.getters.selectedChild
    }
  },
  methods: {
    getShowMessageInfo () {
      if (typeof this.unreadMessagesCount !== 'undefined') {
        return true
      } else {
        return false
      }
    },
    getMessageInfoForChild (child) {
      if (typeof this.unreadMessagesCount === 'undefined') {
        return null
      }
      for (var i = 0; i < this.unreadMessagesCount.length; i++) {
        if (this.unreadMessagesCount[i].child_id === child.id) {
          return this.unreadMessagesCount[i]
        }
      }
      return null
    },
    customSortChildren (children) {
      if (typeof this.unreadMessagesCount === 'undefined') {
        return children
      }
      var order = this.$lodash().sortBy(this.unreadMessagesCount, ['last_message.created_at'], ['asc']).reverse()
      var sortedChildren = []
      var childIdsWithMessages = []
      for (var i = 0; i < order.length; i++) {
        if (this.getChildIsVisibleById(order[i].child_id) === false) {
          continue
        }
        childIdsWithMessages.push(order[i].child_id)
        sortedChildren.push(this.getChild(order[i].child_id))
      }
      var originalOrder = this.getChildIdsInOrder()
      for (var j = 0; j < originalOrder.length; j++) {
        if (childIdsWithMessages.includes(originalOrder[j]) === false) {
          sortedChildren.push(this.getChild(originalOrder[j]))
        }
      }
      return sortedChildren
    },
    isSelected (child) {
      if (this.selectedChild && child.id !== undefined && parseInt(child.id) === parseInt(this.selectedChild.id)) {
        return true
      } else if (this.selectedChild && child.id_child !== undefined && parseInt(child.id_child) === parseInt(this.selectedChild.id)) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>
